import { render } from "./NewAuthorization.vue?vue&type=template&id=5f899f15"
import script from "./NewAuthorization.vue?vue&type=script&lang=js"
export * from "./NewAuthorization.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__